import React from "react";
import { useTable } from "../../Components/useTable";

const InviteList = () => {
  const type = "Invite";
  const headCells = [
    { id: "code", numeric: false, label: "RID" },
    { id: "invitedCount", numeric: false, label: "Invited Count" },
    { id: "inviterId", numeric: false, label: "Inviter ID" },
    { id: "level", numeric: false, label: "Level" },
    { id: "name", numeric: false, label: "Name" },
    { id: "picture", numeric: false, label: "Image" },
    { id: "totalReward", numeric: false, label: "Total Reward" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default InviteList;
